import {useEffect, useState} from "react";

import {Tabs} from "antd";

import {AttachedDocuments} from "./AttachedDocuments/AttachedDocuments.jsx";
import {BomDataTab} from "./BomDataTab.jsx";
import {MaintenanceWork} from "./MaintenanceWork.jsx";
import {StructuredData} from "./StructuredData.jsx";
import {allowAddingDocuments, properties, showAnalyticsTabs} from "@/properties.js";
import {Link} from "react-router-dom";
import {MaintenanceWorks} from "@/variants/index.js";
import {EQUIPMENT_TAB_KEYS} from "@/pages/additional-data/lib/TabDefinitions.js";
import api from "@/api.js";

export const EquipmentInfoTabs = ({
	informationData,
	bomData,
	maint_works = [],
	documentsList = [],
	updateDocsTable,
	item,
}) => {
	const [activeKey, setActiveKey] = useState(EQUIPMENT_TAB_KEYS.BOM);
	const [savedDefaultTab, setSavedDefaultTab] = useState(null);
	const [defaultTabLoaded, setDefaultTabLoaded] = useState(false);

	useEffect(() => {
		api.get("/settings/table-overridden?name=Default Equipment Tab", { omitGlobalError: true })
			.then(json => {
				if (json.data && json.data.length > 0) {
					setSavedDefaultTab(json.data[0]);
				}
			})
			.catch(console.log)
			.finally(() => setDefaultTabLoaded(true));
	}, []);

	useEffect(() => {
		if (!defaultTabLoaded) return;

		if (savedDefaultTab) {
			setActiveKey(savedDefaultTab);
		} else {
			setActiveKey(EQUIPMENT_TAB_KEYS.BOM);
		}
	}, [defaultTabLoaded, savedDefaultTab]);

	const tabConfig = [
		{
			key: EQUIPMENT_TAB_KEYS.INFORMATION,
			label: <span data-testid="equipment-info-tab-information">Information</span>,
			children: <StructuredData structured={informationData} />,
			isEnabled: showAnalyticsTabs,
		},
		{
			key: EQUIPMENT_TAB_KEYS.BOM,
			label: (
				<span data-testid="equipment-info-tab-bill-of-material">{`Bill of Material  (${bomData.length || 0})`}</span>
			),
			children: <BomDataTab equipment={bomData} />,
			isEnabled: true,
		},
		{
			key: EQUIPMENT_TAB_KEYS.MAINTENANCE,
			label: (
				<span data-testid="equipment-info-tab-maintenance-works">{`${MaintenanceWorks.tabTitle} (${maint_works.length || 0})`}</span>
			),
			children: <MaintenanceWork data={maint_works} />,
			isEnabled: true,
		},
		{
			key: EQUIPMENT_TAB_KEYS.PROPOSED_BOM,
			label: (
				<Link
					to={`/proposed?q=${item.material}`}
					target="_blank"
					rel="noopener noreferrer"
					data-testid="equipment-info-tab-proposed-bom"
					onClick={e => e.stopPropagation()}>
					Proposed BOM
				</Link>
			),
			children: null,
			isEnabled: properties.showProposedBomTab,
		},
		{
			key: EQUIPMENT_TAB_KEYS.ATTACHED_DOCUMENTS,
			label: (
				<span data-testid="equipment-info-tab-attached-documents">{`Attached Documents (${documentsList.length || 0})`}</span>
			),
			children: <AttachedDocuments item={item} documentsList={documentsList} updateDocsTable={updateDocsTable} />,
			isEnabled: allowAddingDocuments,
		},
	];

	const tabItems = tabConfig.filter(tab => Boolean(tab.isEnabled));

	return (
		<Tabs
			defaultActiveKey={EQUIPMENT_TAB_KEYS.BOM}
			activeKey={activeKey}
			onTabClick={setActiveKey}
			data-testid="equipment-info-tabs"
			items={tabItems}
		/>
	);
};
